import { SortParams } from '../../../typings/grid';
import { Product } from '../../../typings/products';

export const UPDATE_INTERNAL_PRODUCTS = 'UPDATE_INTERNAL_PRODUCTS';
export type UPDATE_INTERNAL_PRODUCTS = typeof UPDATE_INTERNAL_PRODUCTS;

export interface UpdateInternalProducts {
    type: UPDATE_INTERNAL_PRODUCTS;
    products: Product[];
    sortParams?: SortParams;
}

export function updateInternalProductsAction(products: Product[], sortParams?: SortParams): UpdateInternalProducts {
    return {
        type: UPDATE_INTERNAL_PRODUCTS,
        products,
        sortParams
    };
}
